import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import "./scroll.css";

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      className={`scroll-top ${visible ? "active" : ""}`}
      onClick={scrollToTop}
      id="scrollTop"
    >
      <FaArrowUp />
    </button>
  );
};

export default ScrollToTop;
